import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { Platform } from '@ionic/angular';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AnalyticsService } from 'src/app/core/services/analytics/analytics.service';
import { DatadogRumService } from 'src/app/core/services/datadogrum.service';
import { LoggerService } from 'src/app/core/services/logger.service';
import { RemoteConfigService } from 'src/app/core/services/remote-config.service';
import { FeatureFlagEffects } from 'src/app/core/state/slices/feature-flag/feature-flag.effects';
import { featureFlagFeature } from 'src/app/core/state/slices/feature-flag/feature-flag.reducer';
import { SoftBanEffects } from 'src/app/core/state/slices/soft-ban/soft-ban.effects';
import { softBanFeature } from 'src/app/core/state/slices/soft-ban/soft-ban.reducer';
import { patchCookie } from 'src/app/core/utility/ios-cookie-support';
import { AuthService } from 'src/app/shared/services/auth.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(softBanFeature),
    StoreModule.forFeature(featureFlagFeature),
    EffectsModule.forFeature([SoftBanEffects, FeatureFlagEffects]),
  ],
})
export class CoreModule {
  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
    };
  }

  constructor(
    @Optional() @SkipSelf() coreModuleInstance: CoreModule,
    private loggerService: LoggerService,
    private datadogRumService: DatadogRumService,
    private platform: Platform,
    private authService: AuthService,
    private analyticsService: AnalyticsService,
    private remoteConfig: RemoteConfigService,
  ) {
    if (this.platform.is('cordova') && this.platform.is('ios')) {
      patchCookie();
    }
    this.loggerService.initialise();
    this.datadogRumService.initialise();
    this.analyticsService.initialise();
    this.remoteConfig.initialise();

    this.datadogRumService.manageUserSessionRecording(this.authService.userAuthStatusSubject).subscribe();

    if (coreModuleInstance) {
      throw new Error('CoreModule has already been loaded. Import CoreModule in the AppModule only.');
    }
  }
}
